module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"locationsFound":"{count} found","save":"Save","cancelLabel":"Cancel","failedToFetch":"Failed to search for addresses / areas"},"no":{"locationsFound":"{count} treff","save":"Lagre","cancelLabel":"Avbryt","failedToFetch":"Kunne ikke søke etter adresser / områder"}}')
  delete Component.options._Ctor
}
